import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreCommonModule } from '@core/common.module';
import { NavbarComponent } from 'app/layout/components/navbar/navbar.component';
import { NavbarNotificationComponent } from 'app/layout/components/navbar/navbar-notification/navbar-notification.component';
import { NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';

import { CorePipesModule } from '@core/pipes/pipes.module';
@NgModule({
	declarations: [NavbarComponent, NavbarNotificationComponent],
	imports: [
		CorePipesModule,RouterModule, NgbModule, CoreCommonModule, NgbTooltipModule, TranslateModule],
	providers: [
		{
			provide: NG_SCROLLBAR_OPTIONS,
			useValue: {},
		},
	],
	exports: [NavbarComponent],
})
export class NavbarModule {}
